import { render, staticRenderFns } from "./originalScript.vue?vue&type=template&id=670f6ee6&scoped=true&"
import script from "./originalScript.vue?vue&type=script&lang=js&"
export * from "./originalScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f6ee6",
  null
  
)

export default component.exports